import Vue from 'vue';
import Component from 'vue-class-component';
import PageState from './store/state';
import moduleStore from './store/fesitvalSpeakerPopup';
import ChooseStyle from '../chooseStyle/chooseStyle.vue';
import PopupContainer from '../popupContainer/popupContainer.vue';
import ChooseSpeed from '../chooseSpeed/chooseSpeed.vue';
import SearchSpeaker from '@/views/searchSpeaker/searchSpeaker';
@Component({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    speakerInfo: {
      type: Object
    },
  },
  watch: {
    visible(val) {
      //显示发音人且当前发音人
      if (val && this.speakerInfo.speakerName) {
        this.currentSpeaker = {
          name: this.speakerInfo.speakerName.split('|')[0],
        };
        this.currSpeed = this.speakerInfo.speed;
        this.currStyle = this.speakerInfo.style;
        if(this.speakerInfo && this.speakerInfo.taskId){//克隆声音直接作为当前发音人
          this.currentSpeaker = this.speakerInfo;
        }else{
          this._getSpeakerList('', {//非克隆声音需要查询相关情绪
            keyword: this.speakerInfo.speakerName.split('|')[0],
            pageNum: 1,
            pageSize: 100,
          });
        }
      }
      this.showSpeakerPopup = val;
    }
  },
  components: {
    ChooseStyle,
    PopupContainer,
    ChooseSpeed,
    SearchSpeaker,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class FesitvalSpeakerPopup extends Vue {
  speakerInfo: any;
  state = new PageState();
  showSpeakerPopup = false; //显示当前发音人整体弹框
  showSpeakerDetail = true;//发音人弹框
  // 当前风格
  currStyle = '默认';
  // 当前语速
  currSpeed = '1.0';
  // 是否显示语速选择
  showSpeed = false;
  emotionListMap = {};
  speakerEmotionCacheVOList = [];
  allSpeakerEmotionCacheVOList = [];
  showSpeakerPage = false; //选择所有发音人
  speakerResults = []; // 根据条件筛选出来的发音人
  currentSpeaker: any = {
    defaultSpeaker:{}
  };
  mounted() {}
  /**
   * 关闭弹窗
   */
  closePopup() {
    this.showSpeakerPopup = false;
    //关闭试听
    let styleRef = this.$refs.chooseStyleRef as any;
    styleRef&& styleRef.stopPlay();
    this.$emit('close');
  }
  /**
   * 显示发音人面板
   */
  showSpeaker() {
    this.showSpeakerPage = true;
    let styleRef = this.$refs.chooseStyleRef as any;
    styleRef&& styleRef.stopPlay();
  }
  /**
   * 显示语速
   */
  handleSpeedPopup() {
    //隐藏发音人 + 显示语速
    this.showSpeakerDetail = false;
    this.showSpeed = true;
  }
  closeSpeedPopup() {
    //隐藏语速 + 显示发音人
    this.showSpeakerDetail = true;
    this.showSpeed = false;
  }
  /**
   * 选择情绪
   * @param emtotion
   */
  selectEmotion(value) {
    console.log('选择了情绪', value,value.moodName);
    let moodName = value.moodName;
    this.currStyle = moodName || '默认';
    value.name = value.name.split('|')[0];
    console.log('选择情绪的发音人',this.currentSpeaker,value)
    this.currentSpeaker = { ...this.currentSpeaker, ...value };
    this.currentSpeaker.defaultSpeaker = {...value};//具体风格信息给defaultSpeaker
    this.$emit('change-speaker', {
        ...this.currentSpeaker,
        speed: this.currSpeed,
        style: this.currStyle,
      });
    // this.$emit('change-speaker', {
    //   ...value,
    //   speed: this.currSpeed,
    //   style: this.currStyle,
    // });
  }
  // 获取发音人列表
  _getSpeakerList(type, _params?: any) {
    let params = {
      pageSize: 100,
      pageNum: 1,
    };
    if (type === 'favorite') {
      params['favourite'] = true;
    } else {
      params = { ...params, ..._params };
    }
    this.$http('getSpeakerSearchList', params).then(res => {
        // 全部风格数据格式
            // res.data = [
            //   {
            //     displayOrder: 0,
            //     emotion: 'chat',
            //     emotionName: '聊天',
            //     id: 9,
            //     imageUrl:
            //       'https://mobvoi-speech-public.mobvoi.com/headerImage/66f4adaa745c447f95d3b590cc0c411d.png',
            //   },
            // ];

      if (res.code == 200) {
        let list = res.data.results;
          const _speakerInfo = list.find(
            item => item.name === this.speakerInfo.speakerName.split('|')[0]
          );
          const currentList = [];
          _speakerInfo.speakerEmotionCacheVOList.forEach(item => {
            currentList.push({
              ..._speakerInfo,
              ...item,
            });
          });
          this.currentSpeaker = currentList.find(item => {
            if(item.speaker === this.speakerInfo.speaker
                ||item.speaker.replace('_lpcnet_', '_meet_') === this.speakerInfo.speaker
                ||item.speaker.replace('_meet_', '_lpcnet_') === this.speakerInfo.speaker){
                return item;
            }});
          //封装defaultSpeaker字段-选中默认发音人时根据defaultSpeaker.speaker判断
          let defaultSpeaker = {
            speaker:this.currentSpeaker.speaker,
            name:this.currentSpeaker.name.split('|')[0],
          };
          this.currentSpeaker.defaultSpeaker = defaultSpeaker;
          console.log('111当前的发音人信息---', this.currentSpeaker); 
          this._getSpeakerEmotionList('init');
      }
    });
  }
  // 获取发音人情感列表
  _getSpeakerEmotionList(type?: string) {
    return new Promise((resolve, reject) => {
      let vm = this;
      return this.$http('getSpeakerEmotionList', {})
        .then(res => {
          if (res.code == 200) {
            this.$store.state.emotionListMap = (res.data || []).reduce((target: any, item: any) => {
              target[item.emotion] = { imageUrl: item.imageUrl, emotionName: item.emotionName };
              return target;
            }, {});
            this.speakerEmotionCacheVOList = this.currentSpeaker.speakerEmotionCacheVOList;
            this.allSpeakerEmotionCacheVOList = res.data;
            this._getCurrentSpeakerEmotionList(type);
            console.log('speakerEmotionCacheVOList', this.speakerEmotionCacheVOList);
            resolve(res);
          } else {
            // this
            reject(res);
          }
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  }
  //获取当前发音人所有风格
  _getCurrentSpeakerEmotionList(type?: string) {
    if (!this.speakerEmotionCacheVOList) return;
    this.speakerEmotionCacheVOList = this.speakerEmotionCacheVOList.map(item => {
      const emotion = item.speaker.split('@')[1];
      let emotionInfo;
      if (emotion) {
        emotionInfo = this.allSpeakerEmotionCacheVOList.filter(_item => _item.emotion == emotion);
        item.moodName = (emotionInfo[0] && emotionInfo[0].emotionName) || '默认';
      } else {
        emotionInfo = this.allSpeakerEmotionCacheVOList.filter(
          _item => _item.emotion.trim() == 'default2'
        );
        item.moodName = '默认';
      }
      if (emotionInfo && emotionInfo.length > 0) {
        item.moodImg = (emotionInfo[0] && emotionInfo[0].imageUrl) || item.speaker.headerImage;
      }
      return item;
    });
    if (type === 'init') return;
    const current = this.speakerEmotionCacheVOList.find(item => item.moodName === '默认');
    this.currentSpeaker = { ...this.currentSpeaker, ...current };
    this.currentSpeaker.name = this.currentSpeaker.name.split('|')[0];
    this.$emit('change-speaker', {
      ...this.currentSpeaker,
      speed: this.currSpeed,
      style: this.currStyle,
    });
    // this.currentSpeaker = {...this.currentSpeaker, ...item}
  }
  /**
   * 选择语速
   * @param speed
   */
  chooseSpeed(speed) {
    this.currSpeed = speed;
    this.$emit('change-speaker', {
      ...this.speakerInfo,
      ...{ name: this.speakerInfo.speakerName },
      speed: this.currSpeed,
      style: this.currStyle,
    });
  }
  /**
   * 选择发音人
   * @param speakerInfo
   */
  selectSpeaker(speakerInfo) {
    this.showSpeakerPage = false;
    this.currentSpeaker = speakerInfo;
    //切换发音人之后使用该发音人的默认风格
    this.currStyle = speakerInfo.defaultSpeaker?.moodName||'默认';
    //将风格文字 和 语速放入到放音人对象中
    speakerInfo.speed = this.currSpeed;
    speakerInfo.style = this.currStyle;
    this.speakerEmotionCacheVOList = speakerInfo.speakerEmotionCacheVOList;
    this._getCurrentSpeakerEmotionList();
    console.log('选择后的发音人卡片selectSpeaker', speakerInfo);
    this.$emit('change-speaker', speakerInfo);
  }
  setCurrentSpeaker(speakerInfo){
    let defaultSpeaker = {
        speaker:speakerInfo.speaker,
    };
    this.currentSpeaker = speakerInfo;
    this.currentSpeaker.defaultSpeaker = defaultSpeaker;
  }
}
